import {
  // HomeOutlined,
  // Home,
  Inventory2Outlined,
  Inventory2,
  PersonAddAlt1Outlined,
  PersonAddAlt1,
  AutoGraphOutlined,
  AutoGraph,
  MedicalInformationOutlined,
  MedicalInformation,
} from '@mui/icons-material';
import { HomeFilled, HomeOutlined, Network, NetworkFilled } from '../../components/icons';
import IconReusable from '../../components/IconReusable';

export const getTabConfig = (isPwa) => [
  {
    label: 'Home',
    path: isPwa ? '/pwa-main-menu' : '/',
    inactiveIcon: <IconReusable name="HomeOutlined" size={24}  />,
    activeIcon: <IconReusable name="HomeFilled" size={24}  />,
    key: 'home',
    visible: true,
  },
  //  <IconReusable name="Account" size={40} color="#1976d2" />
  {
    label: 'Inventory',
    path: '/inventory',
    inactiveIcon: <IconReusable name="InventoryOutlined" size={24}  />,
    activeIcon: <IconReusable name="InventoryOutlined" size={24}  />,
    key: 'inventory',
  },
  {
    label: 'Network',
    path: '/my-network',
    inactiveIcon: <IconReusable name="Network" size={24}  />,
    activeIcon: <IconReusable name="NetworkFilled" size={24}  />,
    key: 'my_network',
    visible: true,
  },
  {
    label: 'Benefits',
    path: '/benefits/mybenefits',
    inactiveIcon: <IconReusable name="BenefitsOutlined" size={24}  />,
    activeIcon: <IconReusable name="BenefitsOutlined" size={24}  />,
    key: 'my_benefits',
  },
  
  {
    label: 'Performance',
    path: '/my-performance/network-performance',
    inactiveIcon: <IconReusable name="PerformanceOutlined" size={24}  />,
    activeIcon:  <IconReusable name="PerformanceOutlined" size={24}  />,
    key: 'network_performance',
  },
];

